/**
 * Situação do cadastro de membro nesta plataforma.
 *
 * Autenticação (existir em `auth.users`) é diferente de autorização: o acesso à
 * área de membros exige um cadastro (`profiles`) aprovado e sem bloqueios.
 */

export const MEMBERSHIP_STATUSES = ["pending", "approved", "rejected"] as const;
export type MembershipStatus = (typeof MEMBERSHIP_STATUSES)[number];

/** `none` = usuário autenticado sem cadastro de membro correspondente. */
export type MembershipState = MembershipStatus | "none";

export function isMembershipStatus(value: unknown): value is MembershipStatus {
  return typeof value === "string" && (MEMBERSHIP_STATUSES as readonly string[]).includes(value);
}

export const MEMBERSHIP_LABEL: Record<MembershipState, string> = {
  pending: "Em análise",
  approved: "Aprovado",
  rejected: "Reprovado",
  none: "Sem cadastro",
};

type StateCopy = { title: string; description: string };

/**
 * Texto exibido ao usuário quando o acesso à área de membros é negado por causa
 * da situação do cadastro (e não por um bloqueio vindo da Gestão).
 */
export function membershipCopy(state: MembershipState): StateCopy {
  switch (state) {
    case "pending":
      return {
        title: "Seu cadastro está em análise.",
        description:
          "Recebemos seu cadastro e ele está aguardando aprovação da administração. Você será informado quando houver uma decisão.",
      };
    case "rejected":
      return {
        title: "Seu cadastro não foi aprovado.",
        description:
          "A administração analisou seu cadastro e o acesso à área de membros não foi liberado. O cadastro permanece registrado e pode ser reavaliado pela administração — fale com o suporte da congregação se quiser pedir uma nova análise.",
      };
    case "none":
      return {
        title: "Cadastro de membro não encontrado.",
        description:
          "Não encontramos um cadastro de membro associado a esta conta. Faça seu cadastro na Gestão de cadastros da congregação ou fale com a administração para regularizar a situação.",
      };
    default:
      return {
        title: "Acesso liberado",
        description: "Seu cadastro está aprovado.",
      };
  }
}
